import script from "./StepCodeVerification.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepCodeVerification.vue?vue&type=script&setup=true&lang=ts"

import "./StepCodeVerification.vue?vue&type=style&index=0&id=b83b067a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b83b067a"]])

export default __exports__